<template>
<div class="max-width-limited2">
  <div class="flex row q-my-xl q-px-md result-wrapper">
    <q-img v-if="result.image" :src="isElectron() ? apiUrl + result.image : result.image" class="avatar height-5x" />
    <div class="flex flex-1 items-center text-center">
      <div class="full-width" v-if="result.is_verified"><!-- face recognized -->
        <div v-if="showC">
          <div v-if="!late" class="row"><!-- Coming on schedule == !late -->
            <q-icon name="insert_emoticon" class="face-icon face-icon--good q-mr-sm" />
            <span class="result-phrase">{{$t('pages.results.comingOnSchedule')}}</span>
          </div>
          <div v-else class="row"><!-- Coming not on schedule == late -->
            <q-icon name="mood_bad" class="face-icon face-icon--bad q-mr-sm" />
            <span class="result-phrase">{{$t('pages.results.comingLate')}}</span>
          </div>
        </div>
        <div v-if="showL">
          <div v-if="!dumped" class="row"><!-- Leaving on schedule == !dumped -->
            <q-icon name="insert_emoticon" class="face-icon face-icon--good q-mr-sm" />
            <span class="result-phrase">{{$t('pages.results.leavingOnSchedule')}}</span>
          </div>
          <div v-else class="row"><!-- Leaving not on schedule == dumped -->
            <q-icon name="mood_bad" class="face-icon face-icon--bad q-mr-sm" />
            <span class="result-phrase">{{$t('pages.results.leavingDumped')}}</span>
          </div>
        </div>
        <div class="flex column">
          <div class="result-1 q-mt-sm">{{$t('pages.results.tickSuccess')}}</div>
          <div class="result-2">{{getFullName}}!</div>
        </div>
      </div>
      <div v-else class="flex column"><!-- face is not recognized -->
        <div v-if="result.OFFLINE === true" class="result-2 q-mt-sm">
          {{$t('pages.results.tickOffline')}}
        </div>
        <div v-else class="result-1 q-mt-sm">
          {{$t('pages.results.tickFailure')}}
        </div>
      </div>
    </div>
  </div>
  <q-separator style="height: 3px" />
  <div v-if="showC && result.is_verified && dayDetails && dayDetails.length">
    <div class="plan-title q-mt-xl text-center">{{$t('pages.results.todayPlan')}}</div>
    <div class="day-elements q-mt-xl shadowed border-rounded">
      <div
        v-for="(item, index) in dayDetails"
        v-bind:key="index"
        class="row"
      >
        <div class="col-3 row">
          <div class="little-bar"></div>
          <div class="column justify-center q-pl-lg">
            <div class="semi-bold">{{item.name}}</div>
            <div class="row q-mt-sm">
              <q-icon name="timer" size="24px" />
              <span class="time-from-to">&nbsp;{{dtNormalize(item.dttm_from)}} - {{dtNormalize(item.dttm_to)}}</span>
            </div>
          </div>
        </div>
        <div class="col-6"></div>
        <div class="col-3 q-pl-sm q-pr-sm q-pt-sm q-pb-sm">
          <div class="element-status border-rounded flex flex-center">
            {{$t('pages.results.planElementWaiting')}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-center q-mt-xl">
    <q-btn
      v-if="result.is_verified || result.OFFLINE"
      color="primary"
      :label="$t('pages.results.understood')"
      size="lg"
      icon-right="thumb_up"
      no-caps
      @click="home()"
    />
    <q-btn
      v-else
      color="primary"
      :label="$t('pages.results.tryAgain')"
      size="lg"
      icon-right="autorenew"
      no-caps
      @click="home()"
    />
  </div>
  <div class="hidden-camera" ref="bgVideo" />
</div>
</template>
<script>
/* eslint-disable camelcase */
import { mapGetters, mapState } from 'vuex'
import { API_REQUEST } from '../api.js'
import CamService from './camService'
import { formDate, isElectron } from '../common/helpers'
import { markPerfEvent } from '../modules/urv-perf'

let camService
let picTimeout

export default {
  name: 'Results',

  props: {
    apiUrl: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      showC: false,
      showL: false,
      lateness: null,
      dumpness: null,
      late: null,
      dumped: null,
      isElectron,
      lastPhotoStarted: false,
      lastPhotoUploadPromise: null
    }
  },
  computed: {
    ...mapState(['result', 'tickDetails', 'selectedWorker', 'comingLatenessShift', 'leavingDumpnessShift', 'nextShift']),
    ...mapGetters(['getFullName']),
    dayDetails () { return this.tickDetails.worker_day_details }
  },
  methods: {
    async home () {
      clearTimeout(picTimeout)

      if (!this.lastPhotoStarted) {
        let pic

        try {
          markPerfEvent('last_capture_start', {
            tick_id: this.result && this.result.tick_id
          })
          pic = await camService.getPicture()
          markPerfEvent('last_capture_done', {
            tick_id: this.result && this.result.tick_id
          })
        } catch (e) {
          console.error(e)
          markPerfEvent('last_capture_done', {
            tick_id: this.result && this.result.tick_id,
            status: 'error'
          })
        }

        if (pic) {
          void this.startLastPhotoUpload(pic)
        }
      }

      this.$router.push('/')
    },
    dtNormalize (isoDt) {
      const d = formDate(isoDt)
      return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0')
    },
    noZulu (isoDt) {
      return isoDt.replace('Z', '')
    },
    startLastPhotoUpload (pic) {
      if (this.lastPhotoStarted || !pic) {
        return this.lastPhotoUploadPromise
      }

      this.lastPhotoStarted = true
      markPerfEvent('last_upload_start', {
        tick_id: this.result && this.result.tick_id
      })

      this.lastPhotoUploadPromise = API_REQUEST('setTickPhoto', {
        tick_id: this.result.tick_id,
        type: 'L',
        image: new File([pic], 'camPicLast.jpg')
      })
        .then((photoRes) => {
          markPerfEvent('last_upload_done', {
            tick_id: this.result && this.result.tick_id,
            status: photoRes.http_status || (photoRes.OFFLINE ? 'offline' : 'unknown')
          })
          return photoRes
        })
        .catch((e) => {
          markPerfEvent('last_upload_done', {
            tick_id: this.result && this.result.tick_id,
            status: 'error'
          })
          console.error(e)
          return null
        })

      return this.lastPhotoUploadPromise
    },
    initPhotoTimer () {
      clearTimeout(picTimeout)
      markPerfEvent('last_photo_timer_start', {
        tick_id: this.result && this.result.tick_id,
        delay_ms: 2000
      })
      picTimeout = setTimeout(async () => {
        let pic
        try {
          pic = await camService.getPicture()
        } catch (e) {
          console.error(e)
        }
        if (pic) {
          void this.startLastPhotoUpload(pic)
        }
      }, 2000)
    }
  },
  mounted () {
    markPerfEvent('result_screen_shown', {
      tick_id: this.result && this.result.tick_id
    })
    camService = new CamService(this.$refs.bgVideo)
    camService.initialize()

    this.initPhotoTimer()
    const resultMs = new Date(this.noZulu(this.result.dttm)).getTime()
    console.log('tick time:', this.result.dttm)
    const keyName = `${this.selectedWorker.user_id}_${this.selectedWorker.employee_id}`
    let index = 0
    if (this.nextShift[keyName]) {
      index = 1
    }
    switch (this.tickDetails.type) {
      case 'C':
        this.showC = true
        if (!this.selectedWorker || !this.selectedWorker.employee || !this.selectedWorker.employee.worker_days[index] ||
          !this.selectedWorker.employee.worker_days[index].dttm_work_start) {
          this.late = false
        } else {
          const workStart = this.selectedWorker.employee.worker_days[index].dttm_work_start
          this.lateness = resultMs - new Date(this.noZulu(workStart)).getTime() + this.comingLatenessShift
          this.late = this.lateness > 0
        }
        break
      case 'L':
        this.showL = true
        if (!this.selectedWorker || !this.selectedWorker.employee || !this.selectedWorker.employee.worker_days[index] ||
          !this.selectedWorker.employee.worker_days[index].dttm_work_end) {
          this.dumped = false
        } else {
          const workEnd = this.selectedWorker.employee.worker_days[index].dttm_work_end
          this.dumpness = resultMs - new Date(this.noZulu(workEnd)).getTime() - this.leavingDumpnessShift // dumpness!))
          this.dumped = this.dumpness < 0
        }
        break
    }
  },
  beforeDestroy () {
    clearTimeout(picTimeout)
  }
}
</script>
<style lang="stylus">
$spacing = 32px
$top-row-size = $spacing * 5
  .avatar
    max-width: $top-row-size
    max-height: $top-row-size
    border-radius: ($top-row-size/2)
  .face-icon
    font-size: $spacing
    &--good
      color: $secondary
    &--bad
      color: orange
  .result-1
    font-size: $spacing
    font-weight: bold
  .result-2
    font-size: $spacing
  .plan-title
    font-size: $spacing
    font-weight: bold
  .hr
    width: 100%
    height: 5px
    margin: 0
    padding: 0
  .result-phrase
    line-height: $spacing
  .height-5x
    min-height: $top-row-size
    height: $top-row-size
  .day-elements>div
    height: 96px
    font-size: 16px
  .little-bar
    width: 6px
    height: 100%
    background-color: $info
    border-radius: 3px 0 0 3px
  .time-from-to
    line-height: ($spacing / 1.5)
    font-size: 20px
  .element-status
    background-color: #c7c7c7
    height: 100%
    color: white
    font-weight: bold
  .result-wrapper
    gap: 48px
  .flex-1
    flex: 1
</style>
